import React from 'react'
import { format as dateFormat } from 'date-fns'

import TaskUpdate from './TaskUpdate'

import { formatDateRelative } from '../../../../../../utilities'
import { useUserAPI } from '../../../../../../providers/UserAPIProvider'
import { useEnvironment } from '../../../../../../providers/EnvironmentProvider'
import useStyles from './styles'

type TaskActivityProps = {
  activity: TaskActivityResponse
}

const TaskActivity: React.FC<TaskActivityProps> = ({ activity }) => {
  const { allUsers, loadUser } = useUserAPI()
  const { user: currentUser } = useEnvironment()

  const classes = useStyles()

  const user = React.useMemo(
    () => allUsers[activity.user_id] ?? null,
    [allUsers, activity.user_id]
  )

  const userName = React.useMemo(
    () => (user?.id === currentUser?.id ? 'You' : user?.name),
    [user, currentUser]
  )

  const time = React.useMemo(
    () =>
      `${dateFormat(
        new Date(activity.stamp),
        'h:mm aaa'
      )}, ${formatDateRelative(activity.stamp, true)}`,
    [activity.stamp]
  )

  // Load concerning user if needed
  React.useEffect(() => {
    if (!user) {
      loadUser(activity.user_id)
    }
  }, [user, loadUser, activity.user_id])

  if (activity.action === 'updated') {
    return (
      <>
        {Object.entries(activity.content).map(([type, { previous, value }]) => (
          <label key={type} className={classes.root}>
            <div className={classes.activity}>
              <TaskUpdate
                type={type}
                oldValue={previous}
                newValue={value}
                name={userName}
              />
            </div>
            <div className={classes.time}>{time}</div>
          </label>
        ))}
      </>
    )
  }

  return (
    <label className={classes.root}>
      <div className={classes.activity}>
        Task <span className='emphasize'>{activity.action}</span> by {userName}
      </div>
      <div className={classes.time}>{time}</div>
    </label>
  )
}

export default TaskActivity
